export default "__VITE_ASSET__TmCBnxnR__";